// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'undo';

export const Component = () => (
  <path d='M20.295 4.3c1.532 1.532 2.299 3.4 2.299 5.555s-.767 4.022-2.3 5.508c-1.532 1.532-3.4 2.299-5.555 2.346H3.676l4.07 4.071c.097.048.145.144.145.336 0 .335-.144.479-.48.479a.54.54 0 0 1-.382-.144l-4.885-4.885A.542.542 0 0 1 2 17.183c0-.144.048-.24.144-.335l4.885-4.885a.434.434 0 0 1 .335-.144c.335 0 .527.143.527.479a.435.435 0 0 1-.144.335l-4.071 4.07h11.063c1.868 0 3.496-.67 4.885-2.01 1.34-1.341 2.012-2.97 2.012-4.838 0-1.868-.67-3.496-2.012-4.885-1.389-1.341-3.017-2.012-4.885-2.012H7.412c-.335 0-.527-.144-.527-.48 0-.334.192-.478.527-.478h7.327c2.156 0 4.023.766 5.556 2.3Z' />
);

export const viewBox = '0 0 25 25';
